const ChartLineSvg = ({
  height = 20,
  width = 20,
  viewBox = '0 0 20 20',
}: {
  height?: any;
  width?: any;
  viewBox?: any;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none">
      <path
        d="M2.5 12.5001V14C2.5 14.9334 2.5 15.3998 2.68166 15.7563C2.84144 16.0699 3.09623 16.3254 3.40983 16.4851C3.766 16.6666 4.23249 16.6666 5.16409 16.6666H17.5002M2.5 12.5001V4.16663M2.5 12.5001L5.71116 9.82418L5.71382 9.82205C6.29472 9.33796 6.58573 9.09545 6.90129 8.99695C7.27406 8.88058 7.67559 8.89899 8.0363 9.04862C8.34208 9.17548 8.61021 9.44361 9.14647 9.97986L9.15185 9.98524C9.69643 10.5298 9.96944 10.8028 10.2801 10.9294C10.6478 11.0792 11.0571 11.0921 11.4339 10.9671C11.7534 10.8611 12.0452 10.6063 12.6286 10.0958L17.5 5.83329"
        stroke={'currentColor'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ChartLineSvg;
